import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Simple, versioned localStorage helpers (non-throwing)
type PersistEnvelope<T> = { v: number; data: T }

export function persistSet<T>(key: string, data: T, v = 1) {
  try {
    const payload: PersistEnvelope<T> = { v, data }
    localStorage.setItem(key, JSON.stringify(payload))
  } catch {}
}

export function persistGet<T>(key: string, v = 1): T | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PersistEnvelope<T>
    if (!parsed || typeof parsed !== 'object' || parsed.v !== v) return null
    return parsed.data as T
  } catch {
    return null
  }
}